export const UserDialogModes = {
    CREATE: 0,
    CHANGE: 1
}

export const getContractsId = (contractsAndCompanies) => {
    const parsedContracts = {contracts: []}
    for (const group of contractsAndCompanies) {
        if (group.includes('contract')) {
            parsedContracts.contracts.push(parseInt(group.split('_')[1]))
        }
    }
    return parsedContracts
}

export const createUserFullName = (lastName, firstName, midName) => {
    let fullName = lastName + ' ' + firstName.charAt(0) + '.'
    if (midName) {
        fullName += midName.charAt(0) + '.'
    }
    return fullName
}